module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "footer-area response"
  }, [_c('div', {
    staticClass: "marginauto footercon text-white"
  }, [_c('div', {
    staticClass: "text-center text-six martwl pointer",
    staticStyle: {
      "font-weight": "600",
      "font-size": "20px"
    }
  }, [_vm._v("友情链接")]), _vm._v(" "), _c('div', {
    staticClass: "text-four flex justify-center align-center marbot"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex justify-center align-center"
    }, [_c('div', {
      staticClass: "pointer conone",
      on: {
        "click": function($event) {
          return _vm.toout(item.href)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (index < _vm.list.length - 1) ? _c('div', {
      staticClass: "rightline"
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "horline"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between align-center text-four bcolor"
  }, [_c('div', [_c('div', {
    staticClass: "pointer marf"
  }, [_vm._v("地址：" + _vm._s(_vm.config.address ? _vm.config.address : ''))]), _vm._v(" "), _c('div', {
    staticClass: "pointer"
  }, [_vm._v("电话：" + _vm._s(_vm.config.phone ? _vm.config.phone : ''))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "pointer marf",
    on: {
      "click": function($event) {
        return _vm.toout('https://beian.miit.gov.cn/')
      }
    }
  }, [_vm._v("备案号：" + _vm._s(_vm.config.beianhao ? _vm.config.beianhao : ''))]), _vm._v(" "), _c('div', {
    staticClass: "pointer"
  }, [_vm._v("版权所有：" + _vm._s(_vm.config.banquan ? _vm.config.banquan : ''))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76cc7124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 406
// module chunks = 1